module.exports = __webpack_public_path__ + "static/media/beginner_badge_gray.80f1502d.svg";